import(/* webpackMode: "eager" */ "/home/app/frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/app/providers/ClientWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/features/get-in-touch/ui/modal-form/ModalForm.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/features/modal-info/ui/ModalInfo.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/shared/ui/animation/FadeIn.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/shared/ui/animation/FadeInBlur.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/shared/ui/animation/FadeInGradientMask.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/shared/ui/animation/NumberCounter.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/shared/ui/animation/SplitTextWaveHover.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/shared/ui/button/Button.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/shared/ui/button/ButtonSubmit.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/shared/ui/icon/images/ai.svg");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/shared/ui/icon/images/arrow-right.svg");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/shared/ui/icon/images/close.svg");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/shared/ui/icon/images/divider-marquee.svg");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/shared/ui/icon/images/image-compare.svg");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/shared/ui/icon/images/image.svg");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/shared/ui/icon/images/list-volume.svg");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/shared/ui/icon/images/vision.svg");
;
import(/* webpackMode: "eager", webpackExports: ["ImageWithLoader"] */ "/home/app/frontend/src/shared/ui/image/ImageWithLoader.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/shared/ui/input/Input.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LinkAnchor"] */ "/home/app/frontend/src/shared/ui/link/LinkAnchor.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/shared/ui/lottie/Lottie.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/shared/ui/marquee/Marquee.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/shared/ui/video/Video.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/widgets/cursor/ui/Cursor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Form"] */ "/home/app/frontend/src/widgets/footer/ui/Form.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/widgets/footer/ui/images/bg-d.webp");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/widgets/footer/ui/images/bg.webp");
;
import(/* webpackMode: "eager", webpackExports: ["Logo"] */ "/home/app/frontend/src/widgets/footer/ui/Logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ButtonLetsTalk"] */ "/home/app/frontend/src/widgets/header/ui/ButtonLetsTalk.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Container"] */ "/home/app/frontend/src/widgets/header/ui/Container.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/widgets/header/ui/images/logo.svg");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/widgets/music-toggler/ui/MusicToggler.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/frontend/src/widgets/preloader/ui/Preloader.tsx");
